import { createFeature, createReducer, on } from '@ngrx/store';
import { HistorialMedicoActions } from './historial-medico.actions';
import { HistorialMedicoState, initialHistorialMedicoState } from './historial-medico.state';

const reducer = createReducer(
  initialHistorialMedicoState,
  on(HistorialMedicoActions.loadRecord, (state, { studentId }) => ({
    ...state, studentId, loading: true, error: null, saveSuccess: false,
  })),
  on(HistorialMedicoActions.loadRecordSuccess, (state, { record }) => ({
    ...state, record, loading: false,
  })),
  on(HistorialMedicoActions.loadRecordFailure, (state, { error }) => ({
    ...state, loading: false, error,
  })),
  on(HistorialMedicoActions.saveRecord, (state) => ({
    ...state, saving: true, error: null, saveSuccess: false,
  })),
  on(HistorialMedicoActions.saveRecordSuccess, (state, { record }) => ({
    ...state, record, saving: false, saveSuccess: true,
  })),
  on(HistorialMedicoActions.saveRecordFailure, (state, { error }) => ({
    ...state, saving: false, error,
  })),
);

export const historialMedicoFeature = createFeature<'historialMedico', HistorialMedicoState>({
  name: 'historialMedico',
  reducer,
});
